import { render, staticRenderFns } from "./ProjectEditManage.vue?vue&type=template&id=23504da0&scoped=true&"
import script from "./ProjectEditManage.vue?vue&type=script&lang=js&"
export * from "./ProjectEditManage.vue?vue&type=script&lang=js&"
import style0 from "./ProjectEditManage.vue?vue&type=style&index=0&id=23504da0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23504da0",
  null
  
)

export default component.exports